import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsHomeComponent } from './components/settings-home/settings-home.component';



@NgModule({
  declarations: [
    SettingsHomeComponent
  ],
  imports: [
    CommonModule
  ]
})
export class SettingsModule { }
